export default __webpack_public_path__ + "static/media/rain.7b3e45b0.png";